package com.essntl.features.paymentparameter.ui.paymentparameter

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import com.essntl.features.profile.domain.model.ProfileModel

data class PaymentParameterState(
    val getProfile: State<ProfileModel> = State(),
    val getAllPaymentParameter: State<List<PaymentParameterModel>> = State(),
    val deleteLoading: List<String> = emptyList(),
)
